import { useMutation } from '@apollo/client'
import { RESEND_INVITATION_BY_EMAIL_MUTATION } from '../../gql/mutations'
import { useToasts } from '../../components/complex/Toast'
import { errorMessage } from '../errorMessage'
import { t } from '../i18n'

interface UseResendInvitationOptions {
  onSuccess?: () => void
}

export const useResendInvitation = (options?: UseResendInvitationOptions) => {
  const { addToast } = useToasts()

  const [resendInvitation, { loading: isResending }] = useMutation(
    RESEND_INVITATION_BY_EMAIL_MUTATION,
    {
      onCompleted: (data) => {
        const message =
          data?.resendInvitationByEmail?.message ||
          t('Invitation email resent successfully')
        addToast(message, 'primary')
        if (options?.onSuccess) {
          options.onSuccess()
        }
      },
      onError: (error) => {
        addToast(errorMessage(error), 'danger')
      }
    }
  )

  const handleResendInvite = async (email: string) => {
    if (email) {
      await resendInvitation({
        variables: { email }
      })
    }
  }

  return {
    handleResendInvite,
    isResending
  }
}
